export const url = {
    downIcon: 'https://p0.meituan.net/ingee/8459433a45f064d65293669d3239b5213878.png'
};
export const getTabMode = (tabStyle, tabLevel, length) => {
    const MaxLength = {
        text: 4,
        image: 0
    };
    return length <= MaxLength[tabStyle] ? 'justify' : 'normal';
};
//tab项
export const mv_bid = 'b_daodian_lowcode_pmjxvtlu_mv';
export const mc_bid = 'b_daodian_lowcode_5fbxwgbj_mc';
//组件整体
export const mv_com_bid = 'b_daodian_lowcode_bajk81jj_mv';
export const mc_com_bid = 'b_daodian_lowcode_61x1lkqj_mc';
